var wxPub = require('./wx_lite');

module.exports = wxPub;
